import axios from 'axios'

const restapi = axios.create({baseURL: '/api/v1'})
const sockapi = axios.create({baseURL: '/sapi/v1'})

const HttpErrorHandler = (MainComponent) => {
  const main = MainComponent

  const getErrorMessage = (errorCode) => {
    switch (errorCode) {
      case 400: return 'Invalid Request Parameter'
      case 401: return 'Error 401'
      case 402: return 'Error 402'
      case 403: return 'Error 403'
      case 404: return 'Error 404'
      case 405: return 'Error 405'
      case 500: return 'Error 500'
      default: return `Error ${errorCode}`
    }
  }

  return (error) => {
    if (!error || !error.response) return console.error(error)
    const text = getErrorMessage(error.response.status)
    main.$modal.open({text}).then(({modal}) => { modal.close() })
  }
}

export default {restapi, sockapi, HttpErrorHandler}
export {restapi, sockapi, HttpErrorHandler}